import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/Header';
import styles from './base.module.css';

const BaseLayout: FC = () => {
  return (
    <div className={styles.base}>
      <Header />
      <Outlet />
    </div>
  );
};

export default BaseLayout;
